var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ds-tooltip',_vm._g(_vm._b({attrs:{"is-open":_vm.isTooltipVisible}},'ds-tooltip',_vm.$attrs,false),_vm.$listeners),[_vm._t("reference",null,{"slot":"reference"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }